import { removeObjectFromCanvas } from '@frontend/utils';
import { makeBackgroundColorRectangle } from '@frontend/draw_fields_template/background_color';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { getImage } from '@frontend/constants/image-calculations';
import { fabric } from 'fabric';
import TemplateService from '@frontend/services/api/template';

const getScopePage = () => ShowPageScopeCollector.get(['updateLayoutChanges']);

export async function drawBackgroundColor({ fields, canvas, data }) {
  let backgroundColorField = fields.find(f => f.type === 'Background Color');

  if (!backgroundColorField) {
    let backResponse = await TemplateService.createBackgroundColorField(data.template_id);
    if (!backResponse || !backResponse?.data) return;
    backgroundColorField = backResponse.data;
  }
  
  const { updateLayoutChanges } = getScopePage();

  removeObjectFromCanvas(canvas, backgroundColorField.element_id);

  const backgroundColorRectangle = makeBackgroundColorRectangle({
    fill: 'transparent',
    width: canvas.width,
    height: canvas.height,
    fieldId: backgroundColorField.id,
  }, backgroundColorField,);

  let settings = {};

  backgroundColorRectangle.isSettingsChanged = function (settings) {
    return this.backupData !== JSON.stringify(settings);
  };

  if (Object.hasOwn(data, backgroundColorRectangle.id)) {
    settings = { ...data[backgroundColorRectangle.id] };
    backgroundColorRectangle.backupData = JSON.stringify(data[backgroundColorRectangle.id]);
  }

  backgroundColorRectangle.updateSettings = function (settings) {
    if (!this.isSettingsChanged(settings)) return;
    updateLayoutChanges(canvas.instance_id, backgroundColorRectangle.id, settings);
  };
  
  backgroundColorRectangle.editor.applySettings(settings);
  backgroundColorRectangle.editor.redraw();

  getImage(backgroundColorRectangle.editor.canvas.toDataURL())
    .then((img) => {
      backgroundColorRectangle.fill = new fabric.Pattern({
        source: img,
        repeat: 'no-repeat'
      });

      canvas.add(backgroundColorRectangle);
    });
}
